import { Guid, Lmid } from "@/types"
import AmountWithCurrency, { IAmountWithCurrencyDto } from "./AmountWithCurrency"

export interface IGetAssetBookingViewDto {
    assetId: Guid
    articleId: Guid
    isAssetLabeled: boolean
    articleDescription: string
    lmid: Lmid
    referenceNumber?: string
    referenceValue?: IAmountWithCurrencyDto
    assignAmount: IAmountWithCurrencyDto
    assetVersion: number
    isCurrentVersion: boolean
    supplierOrderNumber: string
    internalOrderNumber?: string | null
}

export default class AssetBookingView {
    assetId: Guid
    articleId: Guid
    isAssetLabeled: boolean
    articleDescription?: string
    lmid?: Lmid
    referenceNumber?: string
    referenceValue?: AmountWithCurrency
    assignAmount?: AmountWithCurrency
    assetVersion: number
    isCurrentVersion: boolean
    supplierOrderNumber: string
    internalOrderNumber?: string | null

    constructor(dto: IGetAssetBookingViewDto) {
        this.assetId = dto.assetId
        this.articleId = dto.articleId
        this.isAssetLabeled = dto.isAssetLabeled
        this.articleDescription = dto.articleDescription
        this.lmid = dto.lmid
        this.referenceNumber = dto.referenceNumber
        this.referenceValue = dto.referenceValue ? new AmountWithCurrency(dto.referenceValue) : undefined
        this.assignAmount = dto.assignAmount ? new AmountWithCurrency(dto.assignAmount) : undefined
        this.assetVersion = dto.assetVersion
        this.isCurrentVersion = dto.isCurrentVersion
        this.supplierOrderNumber = dto.supplierOrderNumber
        this.internalOrderNumber = dto.internalOrderNumber
    }
}
